import { atom } from "jotai";

// Mic-test modal open/close state. Atom so the opener (the control bar's
// settings gear → "Mic settings") and the modal itself can read/write the
// same slot without prop threading.
export const micTestOpenAtom = atom(false);
